module.exports = __webpack_public_path__ + "static/media/failed-icon.0f2fab1b.svg";